import { useCallback } from 'react';

export const POSSIBLE_FILTERS_ENTITIES = {
  PROTOCOL: 'protocol',
  CRM_ACCOUNT: 'CRM - Account',
  CRM_ACCOUNT_DASHBOARD: 'CRM - Account DASHBOARD',
  CRM_ACCOUNT_IMPORT: 'CRM - Account Import',
  CRM_CONTACT: 'CRM - Contact',
  CRM_CONTACT_IMPORT: 'CRM - Contact Import',
  CRM_OPPORTUNITY: 'CRM - Opportunity',
  CRM_NOT_PURCHASED: 'CRM - Not Purchased',
  CRM_OPPORTUNITY_IMPORT: 'CRM - Opportunity Import',
  CRM_OPPORTUNITY_DEADLINES: 'CRM - Opportunity Deadlines',
  CRM_OPPORTUNITY_TIME: 'CRM - Opportunity Time',
  CRM_LEAD: 'CRM - Lead',
  CRM_LEAD_IMPORT: 'CRM - Lead Import',
  CRM_LEAD_DEADLINES: 'CRM - Lead Deadlines',
  CRM_LEAD_CONVERSION_REPORT: 'CRM - Lead Conversion Report',
  CRM_LEAD_TIME: 'CRM - Lead Time',
  REPORT_CHAT_CONVERSATION: 'Report - Chat Conversation',
  REPORT_PERFORMANCE: 'Report - Performance',
  REPORT_SURVEY_ANALYTICS: 'Report - Survey Analytics',
  REPORT_SURVEY_SYNTHETIC: 'Report - Survey Synthetic',
  REPORT_QUALITY_MONITORING: 'Report - Quality Monitoring',
  REPORT_AUDITING_AUTHENTICATION: 'Report - Auditing Authentication',
  REPORT_BROADCAST_LIST_WHATSAPP: 'Report - Broadcast List WhatsApp',
  REPORT_BROADCAST_LIST_SMS: 'Report - Broadcast List SMS',
  REPORT_PBXIP_RECEVEID_CALLS: 'Report - PBXIP Received Calls',
  REPORT_PBXIP_OUTBOUND_CALLS: 'Report - PBXIP Outbound Calls',
  REPORT_WORK_SCHEDULE_ANALYTIC: 'Report - Work Schedule Analytic',
  REPORT_WORK_SCHEDULE_TEAMS: 'Report - Work Schedule Teams',
  REPORT_ADVANCED_URA: 'Report - Advanced URA',
  REPORT_ADVANCED_DIALER: 'Report - Advanced Dialer',
  REPORT_ADVANCED_REPORT_CALLBACK: 'Report - Advanced Report Callback',
  REPORT_ADVANCED_CHATBOT: 'Report - Advanced Chatbot',
  REPORT_CHAT_HEATMAP: 'Report - Chat Heat Map',
  REPORT_CHAT_WORDCLOUD: 'Report - Chat Word Cloud',
  REPORT_CHAT_WORDCLOUD_SCORE: 'Report - Chat Word Cloud by Score',
  REPORT_CHAT_CONVERSATION_ANALYTICS: 'Report - Chat Conversation Analytics',
  REPORT_CHAT_PERFORMANCE: 'Report - Chat Performance',
  REPORT_CHAT_PAUSES: 'Report - Chat Pauses',
  REPORT_CALL_CENTER_INCOMING_CALLS: 'Report - Call Center Incoming Calls',
  REPORT_CALL_CENTER_OUTGOING_CALLS: 'Report - Call Center Outgoing Calls',
  REPORT_CALL_CENTER_PAUSES: 'Report - Call Center Pauses',
  REPORT_CALL_CENTER_PERFORMANCE: 'Report - Call Center Performance',
  CRM_PRODUCT_IMPORT: 'CRM - PRODUCT Import',
  WHATSAPP_BLOCK_LIST: 'Chat - WhatsApp Block List',
  WHATSAPP_BLOCK_LIST_REPORT: 'Chat - WhatsApp Block List Report',
  ALL: 'ALL'
};

export const FILTER_KEYS = {
  PROTOCOL: 'protocol-list-filters',
  CRM_ACCOUNT: 'crm-list-filters-account',
  CRM_ACCOUNT_IMPORT: 'crm-save-custom-account-import',
  CRM_CONTACT: 'crm-list-filters-contact',
  CRM_CONTACT_IMPORT: 'crm-save-custom-contacts-import',
  CRM_OPPORTUNITY: 'crm-list-filters-opportunity',
  CRM_NOT_PURCHASED: 'crm-list-filters-not-purchased',
  CRM_OPPORTUNITY_IMPORT: 'crm-save-custom-opportunity-import',
  CRM_OPPORTUNITY_DEADLINES: 'crm-list-filters-opportunity-deadlines',
  CRM_OPPORTUNITY_TIME: 'crm-list-filters-opportunity-time',
  CRM_LEAD: 'crm-list-filters-lead',
  CRM_LEAD_IMPORT: 'crm-save-custom-lead-import',
  CRM_LEAD_DEADLINES: 'crm-list-filters-lead-deadlines',
  CRM_LEAD_CONVERSION_REPORT: 'crm-list-filters-lead-conversion-report',
  CRM_LEAD_TIME: 'crm-list-filters-lead-time',
  REPORT_CHAT_CONVERSATION: 'report-chat-conversation-list-filters',
  REPORT_PERFORMANCE: 'report-performance-list-filters',
  REPORT_SURVEY_ANALYTICS: 'report-survey-analytics-list-filters',
  REPORT_SURVEY_SYNTHETIC: 'report-survey-synthetic-list-filters',
  REPORT_QUALITY_MONITORING: 'report-quality-monitoring-list-filters',
  REPORT_AUDITING_AUTHENTICATION: 'report-auditing-authentication-list-filters',
  REPORT_BROADCAST_LIST_WHATSAPP: 'report-broadcastlist-whatsapp-list-filetrs',
  REPORT_BROADCAST_LIST_SMS: 'report-broadcastlist-sms-list-filters',
  REPORT_PBXIP_RECEVEID_CALLS: 'report-pbxip-received-calls-list-filters',
  REPORT_PBXIP_OUTBOUND_CALLS: 'report-pbxip-outbound-calls-list-filters',
  REPORT_WORK_SCHEDULE_ANALYTIC: 'report-work-schedule-analytic-list-filters',
  REPORT_WORK_SCHEDULE_TEAMS: 'report-work-schedule-teams-list-filters',
  REPORT_ADVANCED_URA: 'report-advanced-ura-list-filters',
  REPORT_ADVANCED_DIALER: 'report-advanced-dialer-list-filters',
  REPORT_ADVANCED_REPORT_CALLBACK: 'report-advanced-report-callback',
  REPORT_ADVANCED_CHATBOT: 'report-advanced-chatbot-list-filters',
  REPORT_CHAT_HEATMAP: 'report-chat-heatmap-list-filters',
  REPORT_CHAT_WORDCLOUD: 'report-word-cloud-list-filters',
  REPORT_CHAT_WORDCLOUD_SCORE: 'report-word-cloud-list-filters',
  REPORT_CHAT_CONVERSATION_ANALYTICS:
    'report-chat-conversation-alanytics-list-filters',
  REPORT_CALL_CENTER_AUTHENTICATION:
    'report-call-center-authentication-list-filters',
  REPORT_CALL_CENTER_INCOMING_CALLS:
    'report-call-center-incoming-calls-list-filters',
  REPORT_CALL_CENTER_OUTGOING_CALLS:
    'report-call-center-outgoing-calls-list-filters',
  REPORT_CALL_CENTER_PAUSES: 'report-call-center-pauses-list-filters',
  REPORT_CALL_CENTER_PERFORMANCE: 'report-call-center-performance-list-filters',
  CRM_PRODUCT_IMPORT: 'crm-save-custom-product-import',
  WHATSAPP_BLOCK_LIST: 'whatsapp-block-list-filters',
  WHATSAPP_BLOCK_LIST_REPORT: 'whatsapp-block-list-report-filters',
  ALL: 'all-list-filters'
};

export const MEMORIZED_FILTERS_STORAGE_KEY_TO_BE_REMOVED =
  Object.values(FILTER_KEYS);

const getStorageKey = (typeOfFilter) => {
  const key = Object.keys(POSSIBLE_FILTERS_ENTITIES).find(
    (entity) => POSSIBLE_FILTERS_ENTITIES[entity] === typeOfFilter
  );
  return FILTER_KEYS[key] || '';
};

export const useMemorizeFilters = (typeOfFilter = '') => {
  let MEMORIZED_FILTERS_STORAGE_KEY = '';

  switch (typeOfFilter) {
    case 'protocol':
      MEMORIZED_FILTERS_STORAGE_KEY = 'protocol-list-filters';
      break;
    case 'CRM - Account':
      MEMORIZED_FILTERS_STORAGE_KEY = 'crm-list-filters-account';
      break;
    case 'CRM - Account Import':
      MEMORIZED_FILTERS_STORAGE_KEY = 'crm-save-custom-account-import';
      break;
    case 'CRM - Contact':
      MEMORIZED_FILTERS_STORAGE_KEY = 'crm-list-filters-contact';
      break;
    case 'CRM - Contact Import':
      MEMORIZED_FILTERS_STORAGE_KEY = 'crm-save-custom-contacts-import';
      break;
    case 'CRM - Opportunity':
      MEMORIZED_FILTERS_STORAGE_KEY = 'crm-list-filters-opportunity';
      break;
    case 'CRM - Opportunity Import':
      MEMORIZED_FILTERS_STORAGE_KEY = 'crm-save-custom-opportunity-import';
      break;
    case 'CRM - Lead':
      MEMORIZED_FILTERS_STORAGE_KEY = 'crm-list-filters-lead';
      break;
    case 'CRM - Lead Import':
      MEMORIZED_FILTERS_STORAGE_KEY = 'crm-save-custom-lead-import';
      break;
    case 'ALL':
      MEMORIZED_FILTERS_STORAGE_KEY = 'all-list-filters';
      break;
    default:
      MEMORIZED_FILTERS_STORAGE_KEY = getStorageKey(typeOfFilter);
      break;
  }

  const getMemorizedFilters = useCallback(() => {
    const filters = localStorage.getItem(MEMORIZED_FILTERS_STORAGE_KEY);
    if (!filters) return null;
    try {
      return JSON.parse(filters);
    } catch (e) {
      console.warn('Error parsing memorized filters:', e);
      return null;
    }
  }, [MEMORIZED_FILTERS_STORAGE_KEY]);

  const memorizeFilters = useCallback(
    (filters) => {
      const filtersAsString = JSON.stringify(filters);
      localStorage.setItem(MEMORIZED_FILTERS_STORAGE_KEY, filtersAsString);
    },
    [MEMORIZED_FILTERS_STORAGE_KEY]
  );

  const changeUniqueMemorizedFilter = (key, value) => {
    let filters = getMemorizedFilters();
    if (filters) {
      filters = {
        ...filters,
        [key]: value
      };
      const filtersAsString = JSON.stringify(filters);
      localStorage.setItem(MEMORIZED_FILTERS_STORAGE_KEY, filtersAsString);
    }
    return filters;
  };

  const clearMemorizedFilters = useCallback(() => {
    localStorage.removeItem(MEMORIZED_FILTERS_STORAGE_KEY);
  }, [MEMORIZED_FILTERS_STORAGE_KEY]);

  return {
    getMemorizedFilters,
    memorizeFilters,
    clearMemorizedFilters,
    changeUniqueMemorizedFilter
  };
};
